import { render, staticRenderFns } from "./OrganismMenuBarUniverse.vue?vue&type=template&id=82f2a7a0&"
import script from "./OrganismMenuBarUniverse.vue?vue&type=script&lang=js&"
export * from "./OrganismMenuBarUniverse.vue?vue&type=script&lang=js&"
import style0 from "./OrganismMenuBarUniverse.vue?vue&type=style&index=0&id=82f2a7a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomLogo: require('/app/components/atoms/common/AtomLogo.vue').default})
